export default __webpack_public_path__ + "static/media/loadingSpinner.3f396805.gif";